import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import GoogleSquareFilledSvg from "@ant-design/icons-svg/es/asn/GoogleSquareFilled";
import AntdIcon from "../components/AntdIcon";
var GoogleSquareFilled = function GoogleSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GoogleSquareFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  GoogleSquareFilled.displayName = 'GoogleSquareFilled';
}
export default /*#__PURE__*/React.forwardRef(GoogleSquareFilled);